import { Modal, ModalBody } from 'reactstrap';
import styled from 'styled-components';

import crossIcon from '../../assets/img/icons/cross_black.svg';
import csv from '../../assets/img/icons/csv.svg';
import {
  CommonFlex,
  CommonGrid,
  CommonIconWhButton,
  CommonText,
  ExportReportRadioButton,
  ModalCrossIcon,
  IconButton,
} from '../../styledComponents/common';


const BackendExportModal = ({
  isOpen,
  toggle,
  excelExport,
  title,
  timeFormat,
  setTimeFormat,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      style={{ marginTop: `30vh`, maxWidth: `450px` }}
    >
      <ModalBody style={{ padding: `35px 0 15px 0`, position: 'relative' }}>
        <ModalCrossIcon src={crossIcon} alt="" onClick={() => toggle()} />
        <div style={{ padding: `0 30px` }}>
          <CommonText fontSize="18px" fontWeight="600" name="true">
            Export {title} Report
          </CommonText>

          <CommonText style={{ marginTop: `30px` }} fontWeight="600">
            Choose Time Format
          </CommonText>
          <CommonGrid
            columns="auto auto auto"
            style={{
              width: `max-content`,
              marginTop: '15px',
            }}
            disableResponsive={true}
          >
            <CommonFlex
              onClick={() => setTimeFormat('1h5m')}
              style={{
                cursor: 'pointer',
                gap: '10px',
              }}
              disableResponsive={true}
            >
              <ExportReportRadioButton active={timeFormat === '1h5m'} />
              1h 5m
            </CommonFlex>
            <CommonFlex
              onClick={() => setTimeFormat(null)}
              style={{
                cursor: 'pointer',
                gap: '10px',
              }}
              disableResponsive={true}
            >
              <ExportReportRadioButton active={timeFormat === null} />
              1:5
            </CommonFlex>
            <CommonFlex
              onClick={() => setTimeFormat('h:m:s')}
              style={{
                cursor: 'pointer',
                gap: '10px',
              }}
              disableResponsive={true}
            >
              <ExportReportRadioButton active={timeFormat === 'h:m:s'} />
              01:05:25
            </CommonFlex>
          </CommonGrid>
          <CommonText style={{ marginTop: `30px` }} fontWeight="600">
            Choose Format
          </CommonText>
          <CommonGrid columns="1fr 1fr" padding="20px 0 25px 0">
            <IconButton onClick={() => excelExport && excelExport()}>
              <div>
                <img src={csv} alt="excel" width="28px" padding="12px 25px" />
              </div>
              <div>CSV</div>
            </IconButton>
          </CommonGrid>
          {title === 'Clock In/Out' && (
            <CommonText fontWeight="600">
              Note: Images will not be exported.
            </CommonText>
          )}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default BackendExportModal;
